import React, { useState } from 'react';

import EmployerVerifyCodeForm from 'modules/auth/forms/employerForms/EmployerVerifyCodeForm';

import { AuthStage } from '../../../models';
import Header from '../../Header';
import ResendCodePanel from '../../ResendCodePanel';

type EmployerVerifyIdentityProps = {
  email: string;
  lastTwoDigitsOnMobile: string;
  goToNextStage: () => void;
};

const EmployerVerifyIdentity = ({
  email,
  goToNextStage,
  lastTwoDigitsOnMobile,
}: EmployerVerifyIdentityProps) => {
  const [isResendCodePanelOpen, setIsResendCodePanelOpen] = useState(false);

  return (
    <>
      <ResendCodePanel
        email={email}
        isOpen={isResendCodePanelOpen}
        closePanel={() => setIsResendCodePanelOpen(false)}
      />
      <Header
        headerType={AuthStage.Verify}
        lastTwoDigitsOnMobile={lastTwoDigitsOnMobile}
      />
      <div>
        <EmployerVerifyCodeForm
          email={email}
          goToNextStage={goToNextStage}
          openResendPanel={() => setIsResendCodePanelOpen(true)}
          closeResendPanel={() => setIsResendCodePanelOpen(false)}
        />
      </div>
    </>
  );
};

export default EmployerVerifyIdentity;
